import { EMBEDDED_TOKEN_PATTERN } from '../tokens/tokenSerialization';

const URL_PATTERN = /(?:https?:\/\/|www\.)\S+/gi;

// Whole words only, so "animation" and "stylish" do not count. A slash counts as a boundary only
// at line start or after whitespace (`/animate`), so URL path segments like `example.com/animate` do not match.
const VARIANT_SKILL_PATTERN = /(?<!\S\/)\b(?:animate|stylize|style transfer|product[-\s]+shot)\b/i;

export const messageTargetsVariantSkill = (message: string): boolean =>
  VARIANT_SKILL_PATTERN.test(message.replace(EMBEDDED_TOKEN_PATTERN, '').replace(URL_PATTERN, ''));

export const appendVariantCountInstruction = (skillInstructions: string | undefined, count: number): string => {
  const line = `The user already chose ${count} variant(s). Generate exactly ${count}. Do not ask how many they want and ignore any default count in the skill instructions.`;

  return skillInstructions ? `${skillInstructions}\n\n${line}` : line;
};
